import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bspagination',
	templateUrl:'./BSPaginationPage.html',
	styles: [],
	styleUrls:['./BSPaginationPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSPaginationPage
{
	mdContent_138 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.pagination.BSPagination;
\`\`\``;
	mdContent_139 = `\`\`\`java
new BSPagination<>()
\`\`\``;
	mdContent_140 = `\`\`\`java
new BSPagination<>(BSPaginationSizingOptions sizing)
\`\`\``;
	mdContent_141 = `\`\`\`java
new BSPagination<>(BSPaginationAlignmentOptions alignment)
\`\`\``;
	mdContent_142 = `\`\`\`java
new BSPagination<>(BSPaginationSizingOptions sizing, BSPaginationAlignmentOptions alignment)
\`\`\``;
	mdContent_143 = `\`\`\`java
var pagination = new BSPagination<>(BSPaginationSizingOptions.Pagination_Lg);
pagination.createPageLink("Previous").setText("«");
pagination.createPageLink("1").setText("1");
pagination.createPageLink("2").setText("2");
pagination.createPageLink("3").setText("3");
pagination.createPageLink("Next").setText("»");
\`\`\``;
}
